import { render, staticRenderFns } from "./償却不足額.vue?vue&type=template&id=207fcd6b&scoped=true&"
import script from "./償却不足額.ts?vue&type=script&lang=ts&"
export * from "./償却不足額.ts?vue&type=script&lang=ts&"
import style0 from "./償却不足額.css?vue&type=style&index=0&id=207fcd6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207fcd6b",
  null
  
)

export default component.exports